

const Mail = () => {
  return <div className="flex md-mx:hidden text-textColor items-center gap-8 fixed bottom-32 -right-48  rotate-90 ">
    <div className="flex" data-aos="fade-down-left" data-aos-duration="800">
      <a href="mailto:amnaqasmi360@gmail.com" className="dm-mono-medium tracking-widest text-lg hover:text-primaryColor hover:-translate-x-3 transition transform duration-300 ease-in-out">
        amnaqasmi360@gmail.com
      </a>
    </div>
    <hr className="border rounded-full w-40 text-textColor bg-textColor border-textColor " />
  </div>

}

export default Mail
